import React from 'react';
import './alert-error-message.scss';

interface IProps {
    title: string | object;
    message: string | object;
}

const AlertErrorMessage = (props: IProps) => (
    <div className='alert-error-message'>
        <div className='alert-message alert-message--danger alert-error-message__header'>
            {props.title}
        </div>
        <div className='alert-message alert-error-message__body'>{props.message}</div>
    </div>
);

export { AlertErrorMessage };